// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AlertSuccess: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M21,30 C25.9705692,30 30,25.9705692 30,21 C30,16.0294308 25.9705692,12 21,12 C16.0294308,12 12,16.0294308 12,21 C12,25.9705692 16.0294308,30 21,30 Z M19.1377819,25.7654084 L15.3635884,21.9912149 C15.1368802,21.7644712 15.1368802,21.3967836 15.3635884,21.17004 L16.1847633,20.3489006 C16.4115069,20.1221569 16.7791945,20.1221569 17.0059381,20.3489006 L19.5483871,22.891385 L24.9940619,17.4457102 C25.2208409,17.2189311 25.5885285,17.2189311 25.8152367,17.4457102 L26.6364116,18.2668496 C26.8631198,18.4935933 26.8631198,18.8612809 26.6364116,19.0880245 L19.9589923,25.7654439 C19.7322132,25.9921521 19.364561,25.9921521 19.1377819,25.7654084 Z"
                transform="translate(-12 -12)"
            />
        </svg>
    );
};

export default React.memo(AlertSuccess);
